/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TemplateSchedule from './template-schedule';
import TemplateScheduleDetail from './template-schedule-detail';
import TemplateScheduleUpdate from './template-schedule-update';
import TemplateScheduleDeleteDialog from './template-schedule-delete-dialog';

const TemplateScheduleRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TemplateSchedule />} />
    <Route path="new" element={<TemplateScheduleUpdate />} />
    <Route path=":id">
      <Route index element={<TemplateScheduleDetail />} />
      <Route path="edit" element={<TemplateScheduleUpdate />} />
      <Route path="delete" element={<TemplateScheduleDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TemplateScheduleRoutes;
